import { useMutation } from '@tanstack/react-query';
import { IClientInstallation } from '@api/models';
import { removeFileClientInstallation, updateFileClientInstallation } from '@api/services/client-installation.service';

export const useFileUploadClientInstallation = (
    clientInstallationId: string,
    initialData: IClientInstallation,
    setData: (data: any) => void
) => {
    const addFileMutation = useMutation({
        mutationFn: (payload: any) => updateFileClientInstallation(clientInstallationId, payload),
        onSuccess: (updatedInstallation) => {
            // setData((prev: IClientInstallation) => ({
            //     ...prev,
            //     files: [...(prev.files || []), ...newFiles],
            //   }));
            setData(updatedInstallation);
        },
    });

    const removeFileMutation = useMutation({
        mutationFn: (fileId: string) => removeFileClientInstallation(clientInstallationId, fileId),
        onSuccess: (updatedInstallation) => {
            // setData(updatedInstallation);
        },
    });

    const handleAddFiles = (files: FileList | null) => {
        if (!files) return;

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('file', file);
        });

        addFileMutation.mutate(formData);
    };

    const handleRemoveFile = (fileId: string) => {
        removeFileMutation.mutate(fileId);
        setData((prev: IClientInstallation) => {
            const updatedFiles = prev.files?.filter((file: any) => file._id !== fileId) || [];
            return { ...prev, files: updatedFiles };
        });
    };

    return {
        handleAddFiles,
        handleRemoveFile,
        isUploading: addFileMutation.isLoading,
        isRemoving: removeFileMutation.isLoading,
    };
};
